import { ToggleGroup, ToggleGroupItem } from '@savvy-kit/components/toggle-group';

import type { RelationshipKind } from './types';

type Props = {
  readonly activeKinds: ReadonlySet<RelationshipKind>;
  readonly onChange: (kinds: ReadonlySet<RelationshipKind>) => void;
};

function isRelationshipKind(value: string): value is RelationshipKind {
  return value === 'serves' || value === 'refers';
}

const ITEM_CLASSNAME =
  'px-4 py-2 text-sm font-medium bg-white text-secondary hover:text-dark hover:bg-white data-pressed:bg-primary/10 data-pressed:text-primary';

export function RelationshipTypeToggle({ activeKinds, onChange }: Props) {
  return (
    <ToggleGroup
      multiple={false}
      value={[...activeKinds]}
      onValueChange={(next: readonly string[]) => onChange(new Set(next.filter(isRelationshipKind)))}
      variant="outline"
      size="lg"
      className="bg-white"
    >
      <ToggleGroupItem value="serves" className={ITEM_CLASSNAME}>
        Serves
      </ToggleGroupItem>
      <ToggleGroupItem value="refers" className={ITEM_CLASSNAME}>
        Refers
      </ToggleGroupItem>
    </ToggleGroup>
  );
}
